import { __module as n } from "../../../../_virtual/tabbable.js";
(function(u, a) {
  Object.defineProperty(a, "__esModule", {
    value: !0
  }), a.default = i;
  /*!
   * Adapted from jQuery UI core
   *
   * http://jqueryui.com
   *
   * Copyright 2014 jQuery Foundation and other contributors
   * Released under the MIT license.
   * http://jquery.org/license
   *
   * http://api.jqueryui.com/category/ui-core/
   */
  var d = "none", s = "contents", f = /input|select|textarea|button|object|iframe/;
  function c(t, e) {
    return e.getPropertyValue("overflow") !== "visible" || // if 'overflow: visible' set, check if there is actually any overflow
    t.scrollWidth <= 0 && t.scrollHeight <= 0;
  }
  function b(t) {
    var e = t.offsetWidth <= 0 && t.offsetHeight <= 0;
    if (e && !t.innerHTML) return !0;
    try {
      var r = window.getComputedStyle(t), o = r.getPropertyValue("display");
      return e ? o !== s && c(t, r) : o === d;
    } catch {
      return console.warn("Failed to inspect element style"), !1;
    }
  }
  function l(t) {
    for (var e = t, r = t.getRootNode && t.getRootNode(); e && e !== document.body; ) {
      if (r && e === r && (e = r.host.parentNode), b(e)) return !1;
      e = e.parentNode;
    }
    return !0;
  }
  function v(t, e) {
    var r = t.nodeName.toLowerCase(), o = f.test(r) && !t.disabled || r === "a" && t.href || e;
    return o && l(t);
  }
  function p(t) {
    var e = t.getAttribute("tabindex");
    e === null && (e = void 0);
    var r = isNaN(e);
    return (r || e >= 0) && v(t, !r);
  }
  function i(t) {
    var e = [].slice.call(t.querySelectorAll("*"), 0).reduce(function(r, o) {
      return r.concat(o.shadowRoot ? i(o.shadowRoot) : [o]);
    }, []);
    return e.filter(p);
  }
  u.exports = a.default;
})(n, n.exports);
var g = n.exports;
export {
  g as t
};
